import React from 'react';

const HomeIcon = ({ size = 14, ...props }) => (
  <svg
    width={Math.round((size * 13) / 12)}
    height={size}
    viewBox='0 0 13 12'
    fill='currentColor'
    {...props}>
    <path
      d='M 12.328 6.134 L 11.357 10.634 L 9.975 10.634 L 10.871 6.489 L 7.371 1.964 L 2.722 5.822 L 1.683 10.634 L 1.676 10.635 L 3.069 10.635 L 3.065 10.634 L 3.97 6.443 L 9.499 6.443 L 8.594 10.635 L 9.975 10.634 L 9.674 12.032 L 6.91 12.032 L 7.815 7.84 L 5.051 7.84 L 4.146 12.032 L 0 12.032 L 1.508 5.045 L 7.585 0 L 12.328 6.134 Z'
      fillRule='nonzero'
    />
  </svg>
);

export default HomeIcon;
